import { HttpStatusCode } from 'constantsValues';

export const getStatusMessage = (
	statusMessages: {
		items: Array<{
			content: {
				statusMessage: string;
				statusCode: HttpStatusCode;
			};
		}>;
	},
	currentStatus: HttpStatusCode
): string | undefined => {
	if (!statusMessages || !statusMessages.items) return;

	const foundMessage = statusMessages.items.find((item) => Number(item?.content?.statusCode) === currentStatus);

	if (!foundMessage && isNaN(Number(foundMessage?.content?.statusCode))) return;

	return foundMessage.content.statusMessage;
};
